import angular from 'angular';
class VideoProviderHelper {
    constructor($timeout, VideoProviderFactory, activeComponents, Browser, globalUi) {
        this.$timeout = $timeout;
        this.VideoProviderFactory = VideoProviderFactory;
        this.activeComponents = activeComponents;
        this.Browser = Browser;
        this.globalUi = globalUi;
    }
    getFitMode(streamId) {
        const stream = this.VideoProviderFactory.activeProvider.streams.find((s) => s.id === streamId);
        if (!stream)
            return 'cover';
        const person = stream.personConnection.person;
        const shouldLetterbox = person.isOnMobileBrowser();
        return shouldLetterbox ? 'contain' : 'cover';
    }
}
export { VideoProviderHelper };
export default angular
    .module('doxy.providers.video.common.services.helper', [])
    .service('VideoProviderHelper', VideoProviderHelper).name;
